<template>
    <div class="container-fluid">
        <div class="d-block pt-5">                
            <div class="row">
                <div class="col-6 mb-4">
                    <div class="d-flex flex-column h-100">
                        <div class="d-block flex-1">
                            <div class="h1-lg display-tektur">Dashboard</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-3 mb-4">
                    <div class="card h-100 m-0">
                        <div class="card-body h-100">
                            <div class="d-block text-center font-bold mb-3">Jumlah Sekolah</div>
                            <div class="d-block text-xlg display-tektur text-center text-neon mb-4">
                                142
                            </div>
                            <div class="d-block text-center mb-2">
                                <button v-on:click="goToPage('school')" type="button" class="btn btn-sm btn-s-1 btn-white">
                                    <div class="btn-s-1-inner">Lihat Sekolah<i class="fa-solid fa-arrow-right ms-2"></i></div>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-3 mb-4">
                    <div class="card h-100 m-0">
                        <div class="card-body h-100">
                            <div class="d-block text-center font-bold mb-3">Jumlah Universitas</div>
                            <div class="d-block text-xlg display-tektur text-center text-neon mb-4">
                                128
                            </div>
                            <div class="d-block text-center mb-2">
                                <button v-on:click="goToPage('university')" type="button" class="btn btn-sm btn-s-1 btn-white">
                                    <div class="btn-s-1-inner">Lihat Universitas<i class="fa-solid fa-arrow-right ms-2"></i></div>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-3 mb-4">
                    <div class="card h-100 m-0">
                        <div class="card-body h-100">
                            <div class="d-block text-center font-bold mb-3">Jumlah Pelajaran</div>
                            <div class="d-block text-xlg display-tektur text-center text-neon mb-4">
                                56
                            </div>
                            <div class="d-block text-center mb-2">
                                <button v-on:click="goToPage('subject')" type="button" class="btn btn-sm btn-s-1 btn-white">
                                    <div class="btn-s-1-inner">Lihat Pelajaran<i class="fa-solid fa-arrow-right ms-2"></i></div>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-3 mb-4">
                    <div class="card h-100 m-0">
                        <div class="card-body h-100">
                            <div class="d-block text-center font-bold mb-3">Jumlah Rumpun</div>
                            <div class="d-block text-xlg display-tektur text-center text-neon mb-4">
                                21
                            </div>
                            <div class="d-block text-center mb-2">
                                <button class="btn btn-sm btn-s-1 btn-white">
                                    <div class="btn-s-1-inner">Lihat Rumpun<i class="fa-solid fa-arrow-right ms-2"></i></div>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>                
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        goToPage: function(params="") {
            this.$router.push( {
                name : params
            })
        }
    }
}
</script>
